import { render, staticRenderFns } from "./SimpleText.vue?vue&type=template&id=736ca8fb&scoped=true&"
import script from "./SimpleText.vue?vue&type=script&lang=js&"
export * from "./SimpleText.vue?vue&type=script&lang=js&"
import style0 from "./SimpleText.vue?vue&type=style&index=0&id=736ca8fb&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ca8fb",
  null
  
)

export default component.exports